module.exports = __webpack_public_path__ + "img/customerLogo5.3dcb06de.png";